<template>

    <LoopItemPanel title="Slide">

        <div class="canvas-blocks-solar-sliderBravo-LoopItemPanel">

        </div>

    </LoopItemPanel>

</template>

<script>

import LoopItemPanel from "@galaxy/modules/Canvas/resources/js/editor/website/editors/loop/owlCarousel/LoopItemPanel";
import SwitchInput from "@galaxy/modules/Canvas/resources/js/editor/website/editors/inputs/SwitchInput";
import WebsitePageSelector from "@galaxy/modules/Website/resources/js/admin/WebsitePageSelector";
import axios from "../../../../../../../galaxy/modules/Core/resources/js/axiosBuilder";

export default {

    extends: LoopItemPanel,

    components: {
        LoopItemPanel,
        SwitchInput,
        WebsitePageSelector,

    },

    data() {
        return {
            targets: {
                '_self': 'Huidige pagina',
                '_blank': 'Nieuwe pagina',
            },
        };
    },

    methods: {


    },

}
</script>

<style lang="scss" scoped>

.canvas-blocks-solar-sliderBravo-LoopItemPanel {

}

</style>
